<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0">
        <div class="danwei-warp">
            <div class="title">{{row.danwei}}</div>
            <div class="saiqu">{{row.saiqu.name}}</div>
            <div class="duiwu">{{row.mingcheng}}</div>
        </div>

        <div class="step-warp">
            <van-steps direction="vertical"  active-color="#00B388" :active="active">
                <van-step>
                    <div class="step-li">
                        <div class="title">填写秩序册</div>
                        <p class="desc">完善队伍信息</p>
                        <div class="right tiny-btn-0" v-rblink.replace="{name:'ISaiApplyFormStep1',query:{id:row.id}}" v-if="row.memberstatus>0&&row.memberstatus<5">修改信息</div>
                    </div>
                </van-step>
                <van-step>
                    <div class="step-li">
                        <div class="title">完善项目信息</div>
                        <p class="desc">选择项目以及相关运动员</p>
                        <div class="right tiny-btn-0" v-rblink="{name:'ISaiApplyFormStep2',query:{id:row.id}}" v-if="row.memberstatus>1&&row.memberstatus<5">修改信息</div>
                        <div class="right tiny-btn-1" v-rblink="{name:'ISaiApplyFormStep2',query:{id:row.id}}" v-if="row.memberstatus==1">继续操作</div>
                    </div>
                </van-step>
                <van-step v-if="row.saiqu.is_online==2">
                    <div class="step-li">
                        <div class="title">选择食宿行服务</div>
                        <p class="desc">完善随行人员及房间信息</p>
                        <div class="right tiny-btn-0" v-rblink="{name:'ISaiApplyFormStep3',query:{id:row.id}}" v-if="row.memberstatus>2">修改信息</div>
                        <div class="right tiny-btn-1" v-rblink="{name:'ISaiApplyFormStep3',query:{id:row.id}}" v-if="row.memberstatus==2">继续操作</div>
                    </div>
                </van-step>
                <van-step>
                    <div class="step-li">
                        <div class="title">确认订单并支付</div>
                        <p class="desc">完善发票信息，支付费用</p>
                        <div class="right tiny-btn-0" v-rblink="{name:'ISaiApplyFormStep5',query:{id:row.id}}" v-if="row.memberstatus==4">确认订单</div>
                        <div class="right tiny-btn-1" v-rblink="{name:'ISaiApplyFormStep5',query:{id:row.id}}" v-if="row.memberstatus==2||row.memberstatus==5">支付费用</div>
                        <!--<div class="right tiny-btn-0" v-rblink="{name:'SaiApplyFapiao',query:{id:row.id}}" v-if="row.memberstatus==6">申请开票</div>-->
                    </div>
                </van-step>
                <van-step>
                    <div class="step-li">
                        <div class="title">报名成功</div>
                        <p class="desc">报名成功</p>
                        <div class="right tiny-btn-0" v-rblink="{name:'ISaiApplyVideoList',query:{id:row.id}}" v-if="row.memberstatus==6 && row.saiqu.need_video==1 && !row.video_ok">上传视频</div>
                        <div class="right tiny-btn-0" v-rblink="{name:'ISaiApplyVideoList',query:{id:row.id}}" v-if="row.memberstatus==6 && row.saiqu.need_video==1 && row.video_ok">视频已上传</div>
                        <div style="top:30px" class="right tiny-btn-1" v-rblink="{name:'ISaiCertList',query:{id:row.id}}" v-if="row.have_cert">下载证书</div>
                    </div>
                </van-step>
            </van-steps>
        </div>
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .step-warp{
        margin: 0.2rem;
        border-radius:0.2rem;
        padding: 0.2rem;
        background: #fff;
    }
    .step-warp .step-li{
        color: #000;
        position: relative;
    }
    .step-warp .step-li .title{
        font-size: 14px;
    }
    .step-warp .step-li .desc{
        margin-top: 0.2rem;
        font-size: 12px;
        color: #666;
    }
    .step-warp .right{
        position: absolute;
        top:0;
        right: 0;
    }
    .danwei-warp{
        margin: 0.2rem;
        background: #fff;
        box-shadow:0px 0px 10px 0px rgba(204,204,204,0.5);
        border-radius:0.2rem;
        padding: 0.2rem;
    }
    .danwei-warp .title{
        font-size: 18px;
        color: #000;
        margin: 0.4rem 0.2rem 0.2rem 0.2rem;
        font-weight: bold;
    }
    .danwei-warp .saiqu{
        font-size: 14px;
        margin: 0rem 0.2rem 0.4rem 0.2rem;
        color: #666;
    }
    .danwei-warp .duiwu{
        font-size: 12px;
        margin: 0.4rem 0.2rem 0rem 0.2rem;
        color: #999;
    }
    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider,Steps,Step, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';

    Vue.use(Cell).use(CellGroup).use(Steps).use(Step).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyDetail',
        components: {
            [Field.name]: Field,
            PicUploader,
            CaipanPicker,
            JiaolianPicker,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                saiqu_id: this.$route.query.saiqu_id,
                showCaipanPicker:false,
                showJiaolianPicker:false,
                showNumTypePicker:false,
                numTypeColumns: ['身份证', '护照'],
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                row: {
                    id:0,
                    saiqu_name:'',
                    numTypeName:'身份证',
                    danwei:'',
                    memberstatus:0,
                    ldcardtype:1,
                    ldsex:1,
                    saiqu:{

                    },
                    heying:[{name:"选择商户.png",
                        save_name:"h5/2020-05-11/1589187988243621.png",
                        uid:"vc-upload-1589187988243621",
                        url:"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
                    }],
                    caipan:[],
                    jiaolian:[],
                },
            }
        },
        filters: {},
        computed:{
            active(){
                switch (this.row.memberstatus){
                    case 1:
                        return 1;
                    case 2:
                        return 1;
                    case 3:
                        return 2;
                    case 4:
                        return 2;
                    case 5:
                        return 2;
                    case 6:
                        return 3;
                }
            }
        },
        mounted() {
            let that = this;
            that.areaList = area;
            that.row.id = this.$route.query.id;
            this.fetch();

            window.rbMessage = function (data) {
                if(data == 'saiApplyDetailReload'){
//                    alert('that.fetch()')
                    that.fetch();
                }
            }
        },
        watch: {
        },
        destroyed() {
        },
        methods: {
            fetch(){
                let that = this;
                that.$api.get('/api/sai/stepDetail', {
                    id : that.row.id,
                }, (res) => {
                    that.row = Object.assign(that.row, res.data)
                })
            },
            onQuestion(){
                console.log('onQuestion')
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyDetail.vue?eb67f68c